import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';

import { topicTeacherImgs } from '../../images/topicImg'

export class StyleOneCurriculumItem extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    let { Data, onMeiQiaCustomer } = this.props;
    return (
      <div className="topic-style-one-curriculum-item">
        {Data.id === 1 && <img className='posi_ab_box' src={topicTeacherImgs.kecheng_tuijian} alt=""/> }
        <div className='first_section'>
          <div className='item_title_box flex_row'>
            <div className='title'>{Data.title}</div>
            <div className='subtitle'>{Data.subTitle}</div>
          </div>
          <div className='suitable_box'>
            <div className='left_fixed_title flex_row'>适合人群:</div>
            <div className='right_relative_list'>
              {Data.SuitableData && Data.SuitableData.map(item => <div className='suitable_item flex_row' key={item.id}>
                <span className={item.id === 1 ? 'point_icon active' : 'point_icon'}></span><span>{item.content}</span>
              </div>)}
            </div>
          </div>
        </div>
        <div className='second_section'>
          <div className='second_title'>课程内容</div>
          <div className='course_content_list'>
            {Data.CourseContentData && Data.CourseContentData.map(item => <div className='course_content_item' key={item.id}><div>{item.content}</div></div>)}
          </div>
        </div>
        <div className='third_section'>
          <div className='second_title'>服务保障</div>
          <div className='service_list'>
            {Data.ServiceAssuranceData && Data.ServiceAssuranceData.map(item =>
              <div className={item.id > 1 ? 'service_item_img flex_row' : 'service_item flex_row'} key={item.id}>
                <div className='service_item_left_title'>{item.title}</div>
                {item.id > 1 ? <img src={item.url} style={{ marginLeft: '16px' }} alt="" /> : <div className='service_item_right_list'>
                  {item.list && item.list.map(_item => <div className='right_item flex_row' key={_item.id}>
                    <span className='point_icon'></span><span style={{ flex: 1 }}>{_item.content}</span>
                  </div>)}
                </div>}
              </div>)}
          </div>
        </div>
        <div className='four_section'>
          <div className='second_title flex_row'>
            <div>包含班级</div>
            {/* <div className='title_tips'>附带图标的班级，可点击试听</div> */}
          </div>
          <div className='include_class_list'>
            {Data.IncludeClassData && Data.IncludeClassData.map(item => <div className='include_item flex_row' key={item.id}>
              <div className={item.isFree ? 'include_left colorRed flex_row' : 'include_left flex_row'}>{item.title}</div>
              <div className='include_right flex_row'>
                {item.list && item.list.map(_item => <div className={_item.id > 1 ? 'right_item flex_row marginLeft40' : 'right_item flex_row'} key={_item.id}><span className='point_icon'></span><span>{_item.content}</span><img src={topicTeacherImgs.kecheng_shiting} alt="" /></div>)}
              </div>
            </div>)}
          </div>
        </div>
        <div className='five_section'>
          <div className='second_title'>课程优势</div>
          <div className='benefits_list'>
            {Data.CourseBenefitsData && Data.CourseBenefitsData.map(item => <div className='benefits_item flex_row' key={item.id}>
              <img src={item.icon} alt="" />
              <div className='benefits_right_list'>
                {item.list && item.list.map(_item => <div className='benefits_right_item flex_row' key={_item.id}>
                  <span className='point_icon'></span><span>{_item.content}</span>
                </div>)}
              </div>
            </div>)}
          </div>
        </div>
        <div className='six_section'>
          <div className='package_price'>
            <div className='price_box flex_row'>
              <div className='price_title'>套餐组合价</div>
              <div className='price_icon'>￥</div>
              <div className='price'>{Data.price}</div>
              <div className='price_begin'>起</div>
            </div>
            <div className='free_and_pay_box flex_row'>
              <div className='box_btn flex_row' onClick={onMeiQiaCustomer}>免费试听</div>
              <div className='box_btn flex_row active' onClick={onMeiQiaCustomer}>去报名</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleOneCurriculumItem);



// WEBPACK FOOTER //
// ./src/features/style-one/StyleOneCurriculumItem.js